(() => {
  if (window.DFGuide) {
    window.DFGuide.init(document);
    return;
  }

  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-df-guide]')];
    if (scope.matches?.('[data-df-guide]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.guideReady) return;
      root.dataset.guideReady = 'true';
      const opened = [root.dataset.openWidth, root.dataset.openDepth, root.dataset.openHeight].map(Number);
      const closed = [root.dataset.closedWidth, root.dataset.closedDepth, root.dataset.closedHeight].map(Number);
      if (![...opened, ...closed].every(value => Number.isFinite(value) && value > 0)) return;
      const format = new Intl.NumberFormat(document.documentElement.lang || 'fr', { maximumFractionDigits: 2 });
      const unit = root.dataset.unit;
      const measure = values => values.map(value => format.format(value)).join(' × ') + ' ' + unit;
      const tool = root.querySelector('[data-table-tool]');
      if (tool) {
        const widthInput = tool.querySelector('[data-table-width]');
        const depthInput = tool.querySelector('[data-table-depth]');
        const draw = () => {
          const width = Number(widthInput.value), depth = Number(depthInput.value);
          if (!(width > 0 && depth > 0)) return;
          tool.querySelector('[data-width-value]').value = format.format(width) + ' ' + unit;
          tool.querySelector('[data-depth-value]').value = format.format(depth) + ' ' + unit;
          widthInput.setAttribute('aria-valuetext', format.format(width) + ' ' + unit);
          depthInput.setAttribute('aria-valuetext', format.format(depth) + ' ' + unit);
          tool.querySelector('[data-table]').style.aspectRatio = width + '/' + depth;
          const board = tool.querySelector('.table-board');
          board.style.width = opened[0] / width * 100 + '%';
          board.style.aspectRatio = opened[0] + '/' + opened[1];
          tool.querySelector('[data-fit]').textContent = width >= opened[0] && depth >= opened[1] ? root.dataset.fitText : root.dataset.overflowText;
        };
        widthInput.addEventListener('input', draw);
        depthInput.addEventListener('input', draw);
        draw();
      }

      const footprint = root.querySelector('[data-footprint]');
      if (footprint) {
        const scale = 260 / Math.max(opened[0], opened[1]);
        const shape = footprint.querySelector('[data-shape]');
        shape.style.width = opened[0] * scale + 'px';
        shape.style.height = opened[1] * scale + 'px';
        footprint.querySelector('[data-measure]').textContent = measure(opened.slice(0, 2));
        footprint.addEventListener('click', event => {
          const button = event.target.closest('[data-fold]');
          if (!button || !footprint.contains(button)) return;
          const isClosed = button.dataset.fold === 'closed';
          const values = isClosed ? closed : opened;
          footprint.querySelectorAll('[data-fold]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          shape.classList.toggle('is-closed', isClosed);
          shape.style.width = values[0] * scale + 'px';
          shape.style.height = values[1] * scale + 'px';
          footprint.querySelector('[data-measure]').textContent = measure(values);
        });
      }
    });
  }

  document.addEventListener('change', event => {
    const select = event.target.closest('[data-df-collection-sort]');
    const form = select?.closest('[data-df-sort-form]');
    if (!form) return;
    const url = new URL(form.action, window.location.href);
    url.search = window.location.search;
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url.href);
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.DFGuide = { init };
  init(document);
})();
